import type { PlanBillingPeriod } from '@/core/domain';
import {
  createSubscriptionCheckout as createSubscriptionCheckoutCallable,
  type CreateSubscriptionCheckoutResponse,
} from '@/core/services/payments/payment-functions.service';

export type CreateSubscriptionInput = {
  plan_id: string;
  billing_period: PlanBillingPeriod;
  return_base_url?: string;
};

/**
 * Dispara a Cloud Function `createStripeCheckoutSession` (Checkout hospedado Stripe).
 */
export class CreateSubscriptionUseCase {
  async execute(input: CreateSubscriptionInput): Promise<CreateSubscriptionCheckoutResponse> {
    return createSubscriptionCheckoutCallable(input.plan_id, input.billing_period, {
      return_base_url: input.return_base_url,
    });
  }
}
